import { render, staticRenderFns } from "./btProfil.vue?vue&type=template&id=870a9ede&"
import script from "./btProfil.vue?vue&type=script&lang=js&"
export * from "./btProfil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports